import React from 'react';
import { FiCalendar, FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import SEO from '../../../components/SEO';

const AffordableFashionTrends = () => {
    return (
        <div className="bg-white min-h-screen pb-24">
            <SEO
                title="Affordable Fashion Trends Sri Lanka"
                description="How to look your best without breaking the bank. Tips for budget-friendly style in Sri Lanka from Cider Clothings."
                url="/blog/affordable-fashion-trends"
            />
            <div className="max-w-4xl mx-auto px-4 pt-24">
                <Link to="/blog" className="inline-flex items-center text-slate-500 hover:text-slate-900 mb-8 transition-colors">
                    <FiArrowLeft className="mr-2" /> Back to Blog
                </Link>

                <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                    Affordable fashion trends Sri Lanka
                </h1>

                <div className="flex items-center text-slate-500 mb-12">
                    <FiCalendar className="mr-2" /> April 25, 2024
                </div>

                <img
                    src="https://images.unsplash.com/photo-1445205170230-053b830c6050?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
                    alt="Affordable Fashion"
                    className="w-full h-[500px] object-cover rounded-3xl mb-12 shadow-sm"
                />

                <div className="prose prose-lg max-w-none text-gray-600 leading-relaxed">
                    <p className="mb-6">
                        Looking like a million dollars shouldn't cost you a fortune. In Sri Lanka, the market for affordable yet high-quality fashion is booming. Here’s how you can stay trendy on a budget.
                    </p>

                    <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">Capsule Wardrobes</h2>
                    <p className="mb-6">
                        Investing in versatile pieces that can be mixed and matched is the ultimate budget hack. A few high-quality basics from Cider Clothings can create dozens of different looks.
                    </p>

                    <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">Seasonal Sales and Thrift Hunting</h2>
                    <p className="mb-6">
                        Keep an eye out for clearance sales and don't underestimate the power of a good thrift find. Pairing a classic thrifted item with a new trendy piece creates a unique, expensive-looking aesthetic.
                    </p>

                    <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">Accessorize Wisely</h2>
                    <p className="mb-6">
                        Sometimes all an outfit needs is the right belt, bag, or pair of earrings to go from "okay" to "outstanding."
                    </p>

                    <p className="mt-12 italic">
                        At Cider Clothings, our mission is to make fashion accessible to everyone in Sri Lanka. Check out our latest collection for styles that fit your personality and your wallet.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AffordableFashionTrends;
